import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';

const styles = css`
  .CommunityCard {
    text-decoration: none;
    display: block;
    position: relative;
    border-bottom: 2px solid white;
    .CommunityCard_Media {
      background-size: cover;
      background-position: center;
      padding-top:56%;
      position: relative;
      .LabelSold {
        position: absolute;
        top: 10px;
        left: 10px;
        color: white;
        background: ${colors.color2};
        padding: 5px 10px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
      }
      .LabelHeadline {
        position: absolute;
        top: 10px;
        left: 10px;
        color: white;
        background: ${colors.color2};
        padding: 5px 10px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 700;
        text-transform: capitalize;
      }
    }
    .CommunityCard_Content {
      font:700 16px/1.2 ${typography.SansSerif};
      color:${colors.color2};
      padding:15px;
      text-transform: uppercase;
      position: absolute;
      bottom:0;
      left:0;
      background:white;
      @media (min-width: 768px) {
        font:700 18px/1.2 ${typography.SansSerif};
      }
    }
  }
  .CommunityCard_Content-headline {
    font:700 12px/1.2 ${typography.SansSerif};
    color:${colors.color1};
    text-transform: capitalize;
  }
`;

function CommunityCard({ community }) {
  // const soldCommunities = communities.filter(item => item.status === 'Sold Out');
  return (
    <div className={styles}>
      <Link name="community-detail" className="CommunityCard" community={community}>
        <div className="CommunityCard_Media" style={{ backgroundImage: `url('${buildThumbnailUrl(get(community, 'logo.contentUrl'), { width: 800, height: 600 })}')` }}>
          {
            get(community, 'status') === 'Sold Out' &&
            <div className="LabelSold">Sold Out</div>
          }
          {
            get(community, 'headline') &&
            <div className="LabelHeadline">{get(community, 'headline')}</div>
          }
        </div>
        <div className="CommunityCard_Content">
          {get(community, 'name')}
        </div>
      </Link>
    </div>
  );
}

CommunityCard.propTypes = {
  community: PropTypes.object.isRequired,
};

CommunityCard.defaultProps = {
  community: PropTypes.object.isRequired,
};

export default CommunityCard;



// WEBPACK FOOTER //
// ./src/components/CommunityCard.js